import React from 'react';
import { useAuthStore } from '@/stores/auth';
import { PageHeader } from '@/components/PageHeader';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from '@/components/ui/alert-dialog';
import { useUIStore } from '@/stores/ui';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

export default function Settings() {
  const { user, clear } = useAuthStore();
  const { density, setDensity } = useUIStore();
  const nav = useNavigate();

  const logout = () => { clear(); nav('/login'); toast.message('Signed out'); };

  return (
    <div className="space-y-6" data-testid="settings-page">
      <PageHeader eyebrow="Workspace" title="Settings" description="Profile, preferences, and security." />

      <Card title="Profile">
        <div className="grid gap-4 md:grid-cols-2">
          <div className="space-y-1.5"><Label>Full name</Label><Input defaultValue={user?.full_name || ''} data-testid="settings-name-input" /></div>
          <div className="space-y-1.5"><Label>Email</Label><Input defaultValue={user?.email || ''} disabled data-testid="settings-email-input" /></div>
        </div>
      </Card>

      <Card title="Preferences">
        <div className="flex items-center justify-between">
          <div>
            <div className="text-sm font-medium">Compact density</div>
            <div className="text-xs text-[hsl(var(--text-3))]">Tighter rows across tables and lists.</div>
          </div>
          <Switch checked={density === 'compact'} onCheckedChange={(v) => setDensity(v ? 'compact' : 'comfortable')} data-testid="settings-density-switch" />
        </div>
      </Card>

      <Card title="Danger zone">
        <div className="flex items-center justify-between">
          <div>
            <div className="text-sm font-medium">Sign out of this device</div>
            <div className="text-xs text-[hsl(var(--text-3))]">You'll need to sign in again.</div>
          </div>
          <Button variant="secondary" onClick={logout} data-testid="settings-logout-button">Sign out</Button>
        </div>
      </Card>
    </div>
  );
}

function Card({ title, children }) {
  return (
    <div className="rounded-lg border border-white/5 bg-[hsl(var(--surface-1))]">
      <div className="border-b border-white/5 px-5 py-3 text-sm font-medium">{title}</div>
      <div className="p-5">{children}</div>
    </div>
  );
}
